import styles from './OverachieverBanner.module.css'
import { Link } from '@/components/Link'
import { links } from '@/utils/link'
import { byDesign } from '@/infra/design'
import imgArchiveUrl from '@/assets/misc/img_archive.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'

export interface OverachieverBannerProps {
  /**
   * Which workspaces the limit applies to; `null` hides the qualifier.
   */
  workspaceText: string | null
}

export function OverachieverBanner({ workspaceText }: OverachieverBannerProps) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.title}>
          You’ve reached your pickup limit
          {workspaceText !== null && <span> {workspaceText}</span>}!
        </div>
        <div className={styles.description}>
          To unlock more opportunities, please complete some of your open jobs
          first.
        </div>

        <Link to={links.jobs()} className={styles.finishButton}>
          Finish Open Jobs
        </Link>
      </div>
      <div className={styles.illustrationContainer}>
        {byDesign(
          <img
            className={styles.illustration}
            src={imgArchiveUrl}
            alt="Illustration of a hand putting a book on a shelf"
          />,
          <DocumentsDisabledIllustration
            className={styles.illustration}
            label="Illustration of a hand putting a book on a shelf"
          />,
        )}
      </div>
    </div>
  )
}
